import { render } from "./CleaningForm.vue?vue&type=template&id=bad9458a"
import script from "./CleaningForm.vue?vue&type=script&lang=js"
export * from "./CleaningForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__